import MindElementAlignmentType from "../../viewmodel/datatype/MindElementAlignmentType";
import MindElementShapeType from "../../viewmodel/datatype/MindElementShapeType";
import LineMindTypeNode from "../../viewmodel/mindelementdata/LineMindTypeNode";
import TextContent from "../../viewmodel/mindelementdata/mindcontent/TextContent";
import MindElementData from "../../viewmodel/mindelementdata/MindElementData";

class MindmapSDKSubjectData {

    constructor() {
        this.x = -1;
        this.y = -1;
        this.backgroundColor = 0xEEE3B6;
        this.backgroundColorAlpha = 1.0;
        this.borderColor = 0xA6A6A6;
        this.borderColorAlpha = 1.0;
        this.borderWidth = 0;
        this.mindElementShape = MindElementShapeType.Corner;    
        this.alignmentType = MindElementAlignmentType.LEFT;
        this.text = "";
        this.textColor = 0x333333;
        this.textFontSize = 18;
    }


    toMindElementData() {
        let data = new MindElementData();
        data.x = this.x;
        data.y = this.y;
        data.backgroundColor = this.backgroundColor;
        data.backgroundColorAlpha = 1.0;
        data.borderColor = this.borderColor;
        data.borderColorAlpha = this.borderColorAlpha;
        data.borderWidth = this.borderWidth;
        data.mindElementShape = this.mindElementShape;    
        data.alignmentType = this.alignmentType;
        data.textContent = new TextContent(this.text)
        data.textContent.textColor = this.textColor;
        data.textContent.textFontSize = this.textFontSize;
        return data;
    }
}



export default MindmapSDKSubjectData
